/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateGlossaryTermDTO,
  GlossaryTermDTO,
  UpdateGlossaryTermDTO,
} from '../models/index';
import {
    CreateGlossaryTermDTOFromJSON,
    CreateGlossaryTermDTOToJSON,
    GlossaryTermDTOFromJSON,
    GlossaryTermDTOToJSON,
    UpdateGlossaryTermDTOFromJSON,
    UpdateGlossaryTermDTOToJSON,
} from '../models/index';

export interface GlossaryCreateRequest {
    createGlossaryTermDTO: CreateGlossaryTermDTO;
}

export interface GlossaryDeleteRequest {
    glossaryTermId: string;
}

export interface GlossaryUpdateRequest {
    updateGlossaryTermDTO: UpdateGlossaryTermDTO;
}

/**
 * 
 */
export class GlossaryApi extends runtime.BaseAPI {

    /**
     */
    async glossaryCreateRaw(requestParameters: GlossaryCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GlossaryTermDTO>> {
        if (requestParameters['createGlossaryTermDTO'] == null) {
            throw new runtime.RequiredError(
                'createGlossaryTermDTO',
                'Required parameter "createGlossaryTermDTO" was null or undefined when calling glossaryCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/glossary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGlossaryTermDTOToJSON(requestParameters['createGlossaryTermDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GlossaryTermDTOFromJSON(jsonValue));
    }

    /**
     */
    async glossaryCreate(requestParameters: GlossaryCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GlossaryTermDTO> {
        const response = await this.glossaryCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async glossaryDeleteRaw(requestParameters: GlossaryDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['glossaryTermId'] == null) {
            throw new runtime.RequiredError(
                'glossaryTermId',
                'Required parameter "glossaryTermId" was null or undefined when calling glossaryDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/glossary/{glossaryTermId}`.replace(`{${"glossaryTermId"}}`, encodeURIComponent(String(requestParameters['glossaryTermId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async glossaryDelete(requestParameters: GlossaryDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.glossaryDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async glossaryListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GlossaryTermDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/glossary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GlossaryTermDTOFromJSON));
    }

    /**
     */
    async glossaryList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GlossaryTermDTO>> {
        const response = await this.glossaryListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async glossaryUpdateRaw(requestParameters: GlossaryUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateGlossaryTermDTO'] == null) {
            throw new runtime.RequiredError(
                'updateGlossaryTermDTO',
                'Required parameter "updateGlossaryTermDTO" was null or undefined when calling glossaryUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/glossary`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGlossaryTermDTOToJSON(requestParameters['updateGlossaryTermDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async glossaryUpdate(requestParameters: GlossaryUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.glossaryUpdateRaw(requestParameters, initOverrides);
    }

}
